export const SET_RESULTS = 'SET_RESULTS';
export const SET_STEP = 'SET_STEP';
export const SET_PROGRESS = 'SET_PROGRESS';
export const SET_DISPLAY_TEXT = 'SET_DISPLAY_TEXT';
export const SET_FILTERS = 'SET_FILTERS';

const setResults = (results, state) => {
  return { ...state, results };
}

const setStep = (step, state) => {
  return { ...state, step };
}

const setProgress = (progress, state) => {
  return { ...state, progress };
}

const setDisplayText = (displayText, state) => {
  return { ...state, displayText };
}

const setFilters = (filters, state) => {
  return { ...state, filters };
}

export const appReducer = (state, action) => {
  switch (action.type) {
    case SET_RESULTS:
      return setResults(action.results, state);
    case SET_STEP:
      return setStep(action.step, state);
    case SET_PROGRESS:
      return setProgress(action.progress, state);
    case SET_DISPLAY_TEXT:
      return setDisplayText(action.displayText, state);
    case SET_FILTERS:
      return setFilters(action.filters, state);
    default:
      return state;
  }
}